export default __webpack_public_path__ + "static/media/PTSans-BoldItalic.2b7a9f01.ttf";